import 'slick-carousel/slick/slick'

export class Init {
    constructor() {
        this.datePicker = document.querySelector('#report-date-selector');
        this.filesWrapper = document.querySelector('#report-files-list');
        this.datePickerItemsWrapper = this.datePicker.querySelector('.date-picker-items');
        this.datePickerItemsCount = null;
        this.datePickerItemWidth = 100;


        this.fillYears();
        this.initSlick();
        this.handleItemsClick();
    }

    initSlick() {
        $(this.datePickerItemsWrapper).slick({
            slidesToShow: Math.floor(this.datePickerItemsWrapper.clientWidth / this.datePickerItemWidth) > this.datePickerItemsCount
                ? this.datePickerItemsCount : Math.floor(this.datePickerItemsWrapper.clientWidth / this.datePickerItemWidth),
            slidesToScroll: 3,
            infinite: false,
            responsive: [
                {
                    breakpoint: 980, // tablet breakpoint
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 480, // mobile breakpoint
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 2
                    }
                }
            ]
        })
    }

    handleItemsClick() {
        const allItems = this.datePickerItemsWrapper.querySelectorAll('.date-picker-item');
        const activeItem = this.datePickerItemsWrapper.querySelector('.date-picker-item.active');
        if (activeItem) {
            this.filterFiles(activeItem.innerText);
        }
        this.datePickerItemsWrapper.addEventListener('click', function (e) {
            if (e.target.classList.contains('date-picker-item')) {
                e.stopPropagation();
                allItems.forEach(function (item) {
                    if (item.classList.contains('active')) {
                        item.classList.remove('active');
                    }
                });
                e.target.classList.add('active');
                this.filterFiles(e.target.innerText);
            }
        }.bind(this))
    }

    filterFiles(filterValue) {
        const files = this.filesWrapper.querySelectorAll('.file');
        files.forEach(function (file) {
            if (file.getAttribute('data-year') !== filterValue) {
                file.style.display = 'none';
            } else {
                file.style.display = 'flex';
            }
        })
    }

    fillYears() {
        const files = this.filesWrapper.querySelectorAll('.file');
        const yearList = new Set();
        files.forEach(function (file) {
            if (file.getAttribute('data-year')) {
                yearList.add(file.getAttribute('data-year'));
            }
        });

        const sortedArray = Array.from(yearList).sort(function (a, b) { return b - a });
        this.datePickerItemsCount = sortedArray.length;

        sortedArray.forEach(function (year, index) {
            const yearElement = document.createElement('span');
            yearElement.classList.add('date-picker-item');
            if (index === 0) {
                yearElement.classList.add('active');
            }
            yearElement.innerText = year;
            this.datePickerItemsWrapper.appendChild(yearElement);
        }.bind(this));

        if(this.datePickerItemWidth * this.datePickerItemsCount <= this.datePickerItemsWrapper.clientWidth) {
            this.datePickerItemsWrapper.classList.add('short');
        }
    }
}
